/*
 * @Date: 2019-01-23 11:59:17
 * @LastEditors  : lucy
 * @LastEditTime : 2020-01-20 16:28:46
 */

import http from 'axios'
let config = null
const shareConfig = (url) => {
    return http({
        method: 'post',
        url: '/ms/shareShopConfig',
        data: {
            url: url
        },
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
            }
        ],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => {
        if (res.data.status === 200) {
            config = res.data.data
        }
    })
}

const share = async (title, link, imgUrl, desc) => {
    try {
        console.log(config)
        window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appid, // 必填，公众号的唯一标识
            timestamp: config.timestamp, // 必填，生成签名的时间戳
            nonceStr: config.nonceStr, // 必填，生成签名的随机串
            signature: config.signature, // 必填，签名
            jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
        })
        window.wx.checkJsApi({
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareTimeline',
                'onMenuShareAppMessage'
            ],
            success: function (res) {
                console.log('ok', JSON.stringify(res))
            },
            error: function (res) {
                console.log('error', res.errMsg)
            }
        })
        window.wx.ready(() => {
            const shareTimelineConfig = {
                title: title, // 分享标题
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: imgUrl, // 分享图标
                success: function () {
                    console.log('成功分享到朋友圈')
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    console.log('用户取消分享到朋友圈')
                    // 用户取消分享后执行的回调函数
                }
            }
            const shareAppMessageConfig = {
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: imgUrl, // 分享图标
                type: 'link', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function () {
                    console.log('成功分享给朋友')
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    console.log('用户取消分享给朋友')
                    // 用户取消分享后执行的回调函数
                }
            }
            // 分享到朋友圈
            window.wx.onMenuShareTimeline(shareTimelineConfig)
            window.wx.updateTimelineShareData(shareTimelineConfig)
            // 分享给朋友
            window.wx.onMenuShareAppMessage(shareAppMessageConfig)
            window.wx.updateAppMessageShareData(shareAppMessageConfig)
            // 准备分享
            console.log('ready')
            console.log(title, link, imgUrl, desc)
        })
    } catch (_) {
        console.log(_)
        console.log('weappconfig数据获取不正确')
    }
}

export default {
    shareConfig,
    share
}



// WEBPACK FOOTER //
// ./src/wx.js